import { render, staticRenderFns } from "./MoneyInfo.vue?vue&type=template&id=41c2ddee&scoped=true&"
import script from "./MoneyInfo.vue?vue&type=script&lang=js&"
export * from "./MoneyInfo.vue?vue&type=script&lang=js&"
import style0 from "./MoneyInfo.vue?vue&type=style&index=0&id=41c2ddee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2ddee",
  null
  
)

export default component.exports